(() => {
  const selector = '[data-a24-scroll-lift]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = (element) => {
    element.classList.remove('a24-scroll-lift--pending');
    element.classList.add('a24-scroll-lift--visible');
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
      )
    : null;

  const observeWithin = (root = document) => {
    const elements = root.matches?.(selector)
      ? [root]
      : Array.from(root.querySelectorAll(selector));

    elements.forEach((element) => {
      if (element.dataset.a24LiftReady === 'true') return;

      element.dataset.a24LiftReady = 'true';
      element.style.setProperty(
        '--a24-lift-delay',
        `${Number(element.dataset.a24LiftDelay || 0)}ms`,
      );

      if (reducedMotion.matches || !observer) {
        reveal(element);
        return;
      }

      element.classList.add('a24-scroll-lift--pending');
      observer.observe(element);
    });
  };

  const init = () => observeWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    observeWithin(event.target);
  });
})();
